"use strict";
document.addEventListener('DOMContentLoaded', function () {
    const ua = window.navigator.userAgent;
    const isInternetExplorer = ua.indexOf('MSIE ') > -1 || !!ua.match(/Trident.*rv:11\./);
    const isOperaMini = 
    // @ts-expect-error - TS doesn't know about the opera mini object
    ua.indexOf('Opera Mini') > -1 || Object.prototype.toString.call(window.operamini) === '[object OperaMini]';
    if (isOperaMini || isInternetExplorer) {
        // Show browser warning banner
        const unsupportedBrowserEl = document.getElementById('unsupported-browser-warning');
        if (!unsupportedBrowserEl) {
            return;
        }
        unsupportedBrowserEl.style.display = 'block';
        unsupportedBrowserEl.querySelector('.close')?.addEventListener('click', () => {
            unsupportedBrowserEl.style.display = 'none';
        });
        alert('Diese Webseite ist nicht kompatibel mit Ihrem Browser. Wechseln Sie zu einer aktuellen Version von Chrome, Firefox oder Safari, um diese fehlerfrei nutzen zu können.');
    }
});
